import { render, staticRenderFns } from "./getCheck.vue?vue&type=template&id=622b21b8&scoped=true"
import script from "./getCheck.vue?vue&type=script&lang=js"
export * from "./getCheck.vue?vue&type=script&lang=js"
import style0 from "./getCheck.vue?vue&type=style&index=0&id=622b21b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b21b8",
  null
  
)

export default component.exports